import React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import Button, { ButtonTypes } from "../../../../../components/Button";
import { ResponsiveSelect } from "../../../../../components/MobileForm";
import { SegmentedControl } from "../../../../../components/SegmentedControl";
import { ALL_TYPES_LABEL } from "./constants";
import {
  SearchClearButton,
  SearchField,
  SearchGroup,
  SearchIcon,
  SearchInput,
  Toolbar,
} from "./styles";
import { ProgressFilter, ProgressToolbarProps } from "./types";

const ProgressToolbarComponent: React.FC<ProgressToolbarProps> = ({
  filter,
  filterOptions,
  query,
  isNarrowed,
  isCompact,
  onFilterChange,
  onQueryChange,
  onReset,
}) => {
  const selectOptions = filterOptions.map((option) => ({
    value: option.value,
    label: option.value === "all" ? ALL_TYPES_LABEL : option.label,
  }));
  const handleSelectChange = (option: { value: string }) =>
    onFilterChange(option.value as ProgressFilter);
  const handleQueryInput = (event: React.ChangeEvent<HTMLInputElement>) =>
    onQueryChange(event.target.value);
  const clearQuery = () => onQueryChange("");
  const typeFilter = isCompact ? (
    <ResponsiveSelect
      isCompact
      options={selectOptions}
      value={filter}
      onChange={handleSelectChange}
      sheetTitle="Type"
      testId="progress-type-filter"
    />
  ) : (
    <SegmentedControl
      options={filterOptions}
      value={filter}
      onChange={onFilterChange}
      ariaLabel="Filter entries by type"
      testId="progress-type-filter"
    />
  );

  return (
    <Toolbar>
      {typeFilter}
      <SearchGroup>
        {isNarrowed && (
          <Button type={ButtonTypes.link} onClick={onReset}>
            Reset filters
          </Button>
        )}
        <SearchField>
          <SearchIcon>
            <SearchRoundedIcon />
          </SearchIcon>
          <SearchInput
            type="search"
            value={query}
            aria-label="Search entries"
            placeholder="Search entries"
            onChange={handleQueryInput}
          />
          {query !== "" && (
            <SearchClearButton
              size="small"
              aria-label="Clear search"
              onClick={clearQuery}
            >
              <CloseRoundedIcon />
            </SearchClearButton>
          )}
        </SearchField>
      </SearchGroup>
    </Toolbar>
  );
};

export const ProgressToolbar = React.memo(ProgressToolbarComponent);
